import styled from 'styled-components';
import { Tag } from 'ui';
import { StyledMobilePageTitle } from 'admin/components/MobileLayout/style';

export const StyledPage = styled.div`
  ${StyledMobilePageTitle} {
    display: none;
  }

  thead th {
    color: ${({ theme }) => theme.black} !important;
    font-weight: 400 !important;
  }
  
  .sort-arrows {
    padding-left: 5px;
  }

  .is-clickable {
    cursor: pointer;
  }

  .ant-pagination {
    justify-content: center;
  }

  .mobile-list-card-cover {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .mobile-list-card-cover-item > div > div:nth-child(2) {
      color: ${({ theme }) => theme.cardFirstElement};
    }
  }

  .mobile-list-card-body-wrapper {
    row-gap: 0 !important;
  }

  .mobile-list-card-body-item {
    padding-bottom: 8px;
    margin-bottom: 8px;

    .order-download,
    a {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .mobile-list-card-body-item:nth-child(even) {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 200%;
      border-bottom: 1px solid ${({ theme }) => theme.inputAddonBg};
    }

    &:last-child::after {
      display: none;
    }
  }

  .mobile-list-card-body-item:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .mobile-list-card-body-item:nth-last-child(2):nth-child(odd) {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .parent-transaction-card {
    background-color: ${({ theme }) => theme.motherTransactionBg};

    .ant-card-cover,
    .ant-card-body {
      background-color: ${({ theme }) => theme.motherTransactionBg};
    }
  }

  .parent-transaction-row {
    background-color: ${({ theme }) => theme.motherTransactionBg};

    > td {
      background-color: ${({ theme }) => theme.motherTransactionBg};
    }

    &.expanded-row > td {
      border-bottom: 2px solid ${({ theme }) => theme.expandedBorderGray};
    }

    &.expanded-row > td:first-child {
      border-left: 3px solid ${({ theme }) => theme.expandedBorderBlue};
    }
  }

  .child-loading-placeholder {
    height: 50px;
  }

  .child-transactions-container {
    background-color: ${({ theme }) => theme.motherTransactionBg};
    border-left: 3px solid ${({ theme }) => theme.expandedBorderBlue};
  }

  .child-transaction-row {
    display: flex;
    padding: 9px 0px 5px 0px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${({ theme }) => theme.gray01};
    }
  }

  .child-spacer {
    width: 73px;
    flex-shrink: 0;
  }

  .child-cell {
    flex: 1;
    padding: 0 24px;
    display: flex;
    align-items: center;
  }

  .child-date {
    flex: 15;
  }

  .child-number {
    flex: 12;
  }

  .child-type {
    flex: 15;
  }

  .child-supplier {
    flex: 12;
  }

  .child-delivery {
    flex: 12;
  }

  .child-status {
    flex: 12;
  }

  .child-price {
    flex: 12;
  }

  .child-invoice {
    flex: 10;

    a,
    .order-download {
      color: ${({ theme }) => theme.brand02};
      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .ant-table-expanded-row > td {
    padding: 0 !important;
  }

  .ant-table-row-expand-icon {
    margin-right: 8px;
  }

  .price-cell {
    display: flex;
    align-items: center;

    .price-amount {
      flex: 9;
      min-width: 115px;
    }

    .payment-tooltip-wrapper {
      flex: 1;
      display: inline-flex;
      justify-content: center;

      .ant-tooltip .ant-tooltip-inner {
        background-color: ${({ theme }) => theme.paymentStatusPaid} !important;
        color: ${({ theme }) => theme.white} !important;
        border-radius: 15px;
      }

      .ant-tooltip .ant-tooltip-arrow::before {
        background-color: ${({ theme }) => theme.paymentStatusPaid} !important;
      }

      .payment-status-icon {
        font-size: 18px;

        &.paid {
          color: ${({ theme }) => theme.paymentStatusPaid};
        }

        &.unpaid {
          color: ${({ theme }) => theme.paymentStatusUnpaid};
        }
      }
    }
  }
`;

export const StyledTransactionFilterWrapper = styled.div`
  .ant-select {
    max-width: 100% !important;
  }
`;

type TransactionTagType = 'emarket' | 'order' | 'wholesale' | 'motherOrder' | 'motherPurchase' | 'motherReservation' | 'motherDynamicPurchase';

export const TransactionTypeTag = styled(Tag)<{ $tagType: TransactionTagType }>`
  background-color: ${({ theme, $tagType }) => {
    if ($tagType === 'emarket') return theme.eMarketTransactionTag;
    if ($tagType === 'wholesale') return theme.wholesaleTransactionTag;
    if ($tagType === 'motherOrder') return theme.motherOrderTransactionTag;
    if ($tagType === 'motherPurchase') return theme.motherPurchaseTransactionTag;
    if ($tagType === 'motherReservation') return theme.motherReservationTransactionTag;
    if ($tagType === 'motherDynamicPurchase') return theme.motherDynamicPurchaseTransactionTag;
    return theme.orderTransactionTag;
  }} !important;
  color: ${({ theme }) => theme.white};
  border: none;
  border-radius: 15px;
  padding: 3px 12px;
  height: 22px;
  line-height: 16px;
  margin-inline-end: 0;
`;

